import { Link, useParams } from 'react-router-dom'
import ProductCard from '../components/ProductCard'
import { findPartner, productsForPartner } from '../lib/partners'
import { useI18n } from '../lib/i18n'

export default function PartnerProfile() {
  const { t } = useI18n()
  const { slug } = useParams()
  const partner = findPartner(slug)

  if (!partner) {
    return (
      <div className="section py-16">
        <h1 className="text-3xl font-bold text-white">{t('Partner shop not found')}</h1>
        <Link to="/marketplace" className="btn-primary mt-6 inline-flex">
          {t('Back to marketplace')}
        </Link>
      </div>
    )
  }

  const products = productsForPartner(partner)

  return (
    <div className="section py-14">
      <div className="grid gap-8 lg:grid-cols-[1fr_340px]">
        <section>
          <p className="text-sm font-semibold uppercase tracking-wide text-brand-400">{t('Partner shop')}</p>
          <h1 className="mt-3 text-4xl md:text-6xl font-black tracking-tight text-white">{partner.name}</h1>
          <p className="mt-4 text-lg text-ink-300 leading-8">{t(partner.intro)}</p>
          <div className="mt-7 flex flex-wrap gap-3">
            <Link to="/signup" className="btn-primary">
              {t('Join as a partner')}
            </Link>
            <Link to="/catalog" className="btn-secondary">
              {t('Browse full catalog')}
            </Link>
          </div>
        </section>

        <aside className="card p-6">
          <div className="text-xs uppercase tracking-wide text-ink-500">{t('Referral code')}</div>
          <div className="mt-2 font-mono text-2xl font-bold text-brand-300">{partner.code}</div>
          <dl className="mt-6 space-y-4 text-sm">
            <div>
              <dt className="text-ink-500">{t('Region')}</dt>
              <dd className="mt-1 text-white">{t(partner.region)}</dd>
            </div>
            <div>
              <dt className="text-ink-500">{t('Focus')}</dt>
              <dd className="mt-1 text-white">{t(partner.focus)}</dd>
            </div>
          </dl>
          <ul className="mt-6 space-y-2 text-sm text-ink-300">
            {partner.proof.map((line) => (
              <li key={line} className="flex gap-2">
                <span className="text-brand-400">-</span>
                <span>{t(line)}</span>
              </li>
            ))}
          </ul>
        </aside>
      </div>

      <section className="mt-12">
        <h2 className="text-2xl font-bold text-white">{t('Curated demos')}</h2>
        <p className="mt-2 text-ink-400">{t("A focused product shelf for this partner's local market.")}</p>
        <div className="mt-6 grid gap-5 md:grid-cols-2 xl:grid-cols-3">
          {products.map((product) => (
            <ProductCard key={product.slug} product={product} />
          ))}
        </div>
      </section>
    </div>
  )
}
